<template>
  <q-table
    class="score_table"
    :data="tableData"
    :columns="columns"
    row-key="name"
    color="primary"
    :loading="loading"
    :pagination.sync="paginationControl"
  >
      <!-- custom tr -->
      <tr slot="header" slot-scope="props" >
        <th v-for="col in props.cols" :key="col.name"  class="text-center">
           <!-- {{ col.label }} -->
           <q-input v-model="col.label" align="center" hide-underline />
        </th>
      </tr>

      <!-- custom td -->
      <template v-for="column in columns" :slot="'body-cell-' + column.name" slot-scope="props" :props="props">
        <q-td :class="[{ 'not-zero-sum': checkZeroSum(props.row) }]">
          <q-input :class="{ 'last-row': props.row === lastTableRow}" align="center" type="number" @keyup.enter="removeFoucs"
            @change="val => { changeDataByKeyboard(props.row.__index, val, column.name) }" hide-underline :value="props.value"
          />
        </q-td>
      </template>

      <div v-if="props.pagesNumber > 1" slot="bottom" slot-scope="props" class="row flex-center q-py-sm" style="margin-left:auto;">
      <q-btn
        round dense size="sm" icon="fas fa-angle-left" color="cyan-2" class="q-mr-sm"
        :disable="props.isFirstPage"
        @click="props.prevPage"
      />
      <div class="q-mr-sm" style="font-size: small">
        Page {{ props.pagination.page }} / {{ props.pagesNumber }}
      </div>
      <q-btn
        round dense size="sm" icon="fas fa-angle-right" color="cyan-2"
        :disable="props.isLastPage"
        @click="props.nextPage"
      />
  </div>
  </q-table>
</template>

<style lang="scss">
  // .score_table tr:last-child td.text-center input{
  .last-row {
    input {
      /**input**/
      color: #4695EC;
      font-weight:bold;
    }
  }
  .score_table {
    clear: both;
    th.text-center {
      font-weight: bold;
    }
    th.text-center:nth-child(1) input.col.q-input-target {
      color: #d1c4e9;
    }
    th.text-center:nth-child(2) input.col.q-input-target {
      color: #b2dfdb;
    }
    th.text-center:nth-child(3) input.col.q-input-target {
      color: #f8bbd0;
    }
    th.text-center:nth-child(4) input.col.q-input-target {
      color: #ffccbd;
    }
    .not-zero-sum {
      background: #ef25613d;
    }
  }
</style>

<script>
import { mapGetters, mapMutations } from 'vuex'
// mapActions
// changeCell
export default {
  data () {
    return {
      // As it is updated automatically by libraly, it is difined as local variable not in vuex
      paginationControl: { rowsPerPage: 5, page: 1 }
    }
  },
  methods: {
    changeDataByKeyboard (index, val, player) {
      const updateVal = {targetIndex: index, val: val, player: player}
      this.changeCell(updateVal)
    },
    ...mapMutations('ScoreTable', {
      changeCell: 'changeCell'
    }),
    removeFoucs () {
      document.activeElement.blur()
    },
    checkZeroSum (row) {
      let sum = 0
      for (let key in row) {
        if (key === '__index') {
          continue
        }
        sum += row[key]
      }
      return sum !== 0
    }
  },
  computed: {
    ...mapGetters('ScoreTable', {
      columns: 'getColumns',
      tableData: 'getTableData',
      lastTableRow: 'getLastRow',
      currentPageNum: 'getCurrentPageNum',
      loading: 'getLoading'
    })
  },
  watch: {
    currentPageNum () {
      this.paginationControl.page = this.currentPageNum
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheScoreTable.vue